import api from "./api";
import { IParams } from "../types/interfaces";

export const createSubscription = async ({
  planId,
  receiptId,
}: {
  planId: number;
  receiptId: string;
}) => {
  const response = await api.post("/subscriptions", {
    planId,
    receiptId,
  });
  return response.data;
};

export const upgradeSubscription = async ({
  planId,
  receiptId,
}: {
  planId: number;
  receiptId: string;
}) => {
  const response = await api.put("/subscriptions", {
    planId,
    receiptId,
  });
  return response.data;
};

export const renewSubscription = async ({
  id,
  receiptId,
}: {
  id: number;
  receiptId: string;
}) => {
  const response = await api.put("/subscriptions/renew", {
    id,
    receiptId,
  });
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.delete(`/subscriptions`);
  return response.data;
};

export const getSubscriptions = async (params: IParams) => {
  const response = await api.get("/subscriptions", { params });
  return response.data;
};

// Admin actions
export const adminCreateSubscription = async (data: {
  userId: number;
  planId: number;
  active: boolean;
  notes?: string;
  receiptId?: string;
}) => {
  const response = await api.post("/subscriptions/admin", data);
  return response.data;
};

export const toggleSubscription = async (id: number) => {
  const response = await api.put(`/subscriptions/${id}/toggle`);
  return response.data;
};

export const deleteSubscription = async (id: number) => {
  const response = await api.delete(`/subscriptions/${id}`);
  return response.data;
};

export const adminCancelSubscription = async (id: number) => {
  const response = await api.put(`/subscriptions/${id}/cancel`);
  return response.data;
};

export const getSubscriptionPayments = async (id: number) => {
  const response = await api.get(`/subscriptions/${id}/payments`);
  return response.data;
};
